// mds-dojo — dijit/Toolbar — FAITHFUL port of references/dijit/Toolbar.js.
// A Toolbar widget, used to hold things like dijit/Editor buttons. declare from the
// faithful runtime. `require` + has("dijit-legacy-requires") ready() preload block
// removed (no AMD loader); unused require/has/keys/ready imports dropped.
import declare from '../dojo/_base/declare-runtime'; // declare
import _Widget from './_Widget';
import _KeyNavContainer from './_KeyNavContainer';
import _TemplatedMixin from './_TemplatedMixin';

export default declare('dijit.Toolbar', [_Widget, _TemplatedMixin, _KeyNavContainer], {
  // summary:
  //		A Toolbar widget, used to hold things like `dijit/Editor` buttons

  templateString:
    '<div class="dijit" role="toolbar" tabIndex="${tabIndex}" data-dojo-attach-point="containerNode">' +
    '</div>',

  baseClass: 'dijitToolbar',

  _onLeftArrow: function () {
    this.focusPrev();
  },

  _onRightArrow: function () {
    this.focusNext();
  },
});
